<script>
import DataProvider from './DataProvider.vue';
import KindergartenHolidayRepository from '../../js/repository/KindergartenHolidayRepository';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        kindergartenId: {
            type: Number,
            required: true,
        },
        callback: {
            type: Function,
            required: false,
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: KindergartenHolidayRepository.findYearsByKindergarten,
                params: [this.kindergartenId],
                callback: this.callback,
                reload: this.load,
            },
            scopedSlots: this.$scopedSlots,
        });
    },
};
</script>
